import { UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools.definitions";
import { ProgramAffectationDTO } from "../program/program.dto";
import { PatientDTO } from "./user.dto";

/**
 * Type to know how many db records will be affected by the deletion of a coach profile  
 */
export type CoachDeletionCost = {
    impactedPatient: number, impactedMedGroup: number, impactedCoach: number, impactedExerciseTemplate: number, impactedExercise: number,
    impactedSession: number, impactedProgram: number, impactedMessage: number, impactedNote: number, impactedEvaluation: number,
    impactedTemplateHealthCheck: number, impactedAttachment: number, impactedHealthCheck: number
};

/**
 * Status code of the checkUid function
 */
export enum CheckUidResult {
    /**
     * Uid can be use to create a user
     */
    SUCCESS = 1,
    /**
     * A user exist in db with the same uid
     */
    USER_EXIST = 2,
    /**
     * Provided uid is not reachable by mail
     */
    UNREACHABLE = 3,
    /**
     * Unknown error occurred during check
     */
    UNKNOWN_ERROR = 4
}

/**
 *Answer of server when getting access to patient file
 */
export enum GetAccessCode {
    SUCCESS = 1,
    NOT_FOUND = 2,
    UNKNOWN_ERROR = 3
}


/** This is only a class merging PatientDTO & ProgramAffectation */
export interface MonitoredPatient extends PatientDTO {
    programs: ProgramAffectationDTO[];
    activePrograms: ProgramAffectationDTO[];
    programStartDate?: UnixTimestamp;
    programEndDate?: UnixTimestamp;
}

export enum CoachSpecialties {
    APA = "APA"
}